import $ from 'cash-dom'
import { updateCartAttribute } from '../resources/shopify-cart'

const updateCartTierMessage = (data) => {
  const message = $('[data-element="tier-exceeded-message"]')
  const maxQuantity = data.attributes?.cover_replacement_max_quantity === true

  const id = Pura.environment.production ? '7660283494509' : '14693567365485'
  const items = data.items.filter(item => item.product_id.toString() === id)
  const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0)

  if (maxQuantity) {
    updateCartAttribute('cover_replacement_max_quantity', null)
  }

  if (maxQuantity || totalQuantity > 8) {
    message.removeClass('hidden')
  } else {
    message.addClass('hidden')
  }
}

export { updateCartTierMessage }
